/**
 * Helper utilities for Sprint components
 */

/**
 * Get user initials from name
 * Returns first letter of first two words, max 2 characters
 */
export const getInitials = (name: string): string => {
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}
